import React, { Component } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import AccountTransactionServices from "../../../services/axiosServices/apiServices/AccountTransactionServices";
import SwalServices from "../../../services/swalServices/SwalServices";
import { getAuthProps } from "../../../utils/AuthenticationLibrary";
import ButtonGrp from "../../../components/UIComponent/Buttons/ButtonGrp";
import { GeneralPurchasePopUp } from "./GeneralPurchaseTable";
import { isValidForm } from "../../../utils/validation/CommonValidator.js";
import { CommonValidationMessages } from "../../../utils/Messages.js";
import moment from "moment";
import { decryptAES } from "../../../utils/Encryption.js";
import { Navigate } from "react-router-dom";
import TransactionStockServices from "../../../services/axiosServices/apiServices/TransactionStockServices.js";
import { permission } from "../../../utils/enums/ValidationMessage.js";

class GeneralPurchase extends Component {
    constructor(props) {
        super(props);
        this.accountTransactionServices = new AccountTransactionServices();
        this.transactionStockServices = new TransactionStockServices();
        this.SwalServices = new SwalServices();
        this.state = {
            permissions: {
                isAddEdit: false,
                isDelete: false,
                isView: false,
            },
            isModalOpen: false,
            isSaving: false,
            isTable2Expanded: false,
            urlId: 0,
            rowData: [],
            colDefs: [],
            prop: {},
            caption: "",
            colName: "",
            paginationPageSize: 50, // Number of rows per page
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            materialInwardDetails: {
                prefix: "",
                idGeneralPurchase: 0,
                updateStatus: 0,
                //prefix: "",
                inwardNo: "",
                inwardDate: moment(new Date().toISOString()).format('YYYY-MM-DD'),
                inwardType: [
                    {
                        id: 1,
                        name: 'INTRASTATE'
                    },
                    {
                        id: 2,
                        name: 'INTERSTATE'
                    }
                ],
                inwardTypeId: 1,
                inwardTypeName: "INTRASTATE",
                gatePassNoList: [],
                mainGatePassNoList: [],
                idGatePass: 0,
                gatePassNo: "",
                modeOfDelivery: "",
                partyAccountGeneral: [],
                mainPartyAccountGeneral: [],
                idPartyAccount: 0,
                partyACName: "",
                modeOfPayment: "",
                personName: "",
                invoiceNo: "",
                invoiceDate: "",
                vehicleNo: "",
                selectFile: "",
                fileExtension: "",
                selectedFile: null,
                inwardByList: [
                    {
                        id: 1,
                        name: 'Demo1'
                    },
                    {
                        id: 2,
                        name: 'demo2'
                    }
                ],
                idInwardBy: "",
                inwardBy: "",
                address: "",
                networkConfiguration: [],
                idFinancialYear: 0,
            },
            inwardItemDetails: {
                itemNameList: [],
                idGeneralProduct: 0,
                productName: "",
                unitList: [],
                idUnit: 0,
                unitDescription: "",
                quantity: "",
                rate: "",
                amount: "",
                discount: "",
                discountAmt: 0,
                chargesAmt: "",
                netTotal: "",
                taxGroupList: [],
                //idTaxStructure: 0,
                //taxStructureName: "",
                idTaxGroup: 0,
                taxGroup: "",
                sgst: 0,
                sgstAmount: 0,
                cgst: 0,
                cgstAmount: 0,
                igst: 0,
                igstAmount: 0,
                netPayble: "",
                remarks: "",
                key: "",
            },
            partyAccountGeneralForSearch: [],
            itemNameListForSearching: [],
            generalPurchaseRowData: [],
            demoList: [
                {
                    id: 1,
                    name: 'Demo1'
                },
                {
                    id: 2,
                    name: 'demo2'
                }
            ],
            amountDetails: {
                totalQty: "",
                totalAmt: "",
                extraCharges: "",
                totalDiscountAmt: "",
                taxableAmt: "",
                taxAmt: "",
                tcsPercentage: "",
                tcsAmt: "",
                totalTaxAmt: "",
                adjustableAmt: "",
                finalAmt: "",
            },
            validStateForMaterialInwardDetails: {
                isValid: true,
                error: {},
            },
            validStateForInwardItemDetails: {
                isValid: true,
                error: {},
            },
            validationRulesForMaterialInwardDetails: {
                inwardTypeId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "inward type"
                        ),
                    },
                ],
                idGatePass: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "gate pass no"
                        ),
                    },
                ],
                idPartyAccount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "vendor"
                        ),
                    },
                ],
                // modeOfPayment: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "mode of payment"
                //         ),
                //     },
                // ],
                // personName: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "person name"
                //         ),
                //     },
                // ],
                // invoiceNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "invoice no"
                //         ),
                //     },
                // ],
                // invoiceDate: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "invoice date"
                //         ),
                //     },
                // ],
                // vehicleNo: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "vehicle no"
                //         ),
                //     },
                // ],
                // selectFile: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "file"
                //         ),
                //     },
                // ],
                // inwardBy: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "inward by"
                //         ),
                //     },
                // ],
                // address: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "address"
                //         ),
                //     },
                // ],
            },
            validationRulesForInwardItemDetails: {
                idGeneralProduct: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "item name"
                        ),
                    },
                ],
                // idUnit: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "unit"
                //         ),
                //     },
                // ],
                quantity: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "quantity"
                        ),
                    },
                ],
                rate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "rate"
                        ),
                    },
                ],
                // amount: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "amount"
                //         ),
                //     },
                // ],
                // discount: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "discount"
                //         ),
                //     },
                // ],
                // chargesAmt: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "charges amount"
                //         ),
                //     },
                // ],
                // netTotal: [
                //     {
                //         type: "require",
                //         message: CommonValidationMessages.FieldRequired.replace(
                //             "{0}",
                //             "net total"
                //         ),
                //     },
                // ],
                idTaxGroup: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "tax group"
                        ),
                    },
                ],
            }
        };
        this.gridApi = null;
    }

    toggleExpandCollapseTable = (tableNumber) => {
        this.setState((prevState) => {
            if (tableNumber === 2) {
                return { isTable2Expanded: !prevState.isTable2Expanded };
            } else if (tableNumber === 3) {
                return { isTable3Expanded: !prevState.isTable3Expanded };
            } else {
                return {};
            }
        });
    };

    handleCellClick = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        let data = this.state.materialInwardDetails;
        data.idGeneralPurchase = event.data.idGeneralPurchase;
        this.setState({
            materialInwardDetails: data
        }, () => {
            this.procSelectAllRecord2GridviewSP(event.data[this.state.colName], "General Purchase");
        })
        //}
    };

    handleCellClickItemList = (event) => {
        //if (event.colDef.field === "piQty") {
        //debugger
        //let itemDetail = this.state.inwardItemDetails;
        let data = [...this.state.generalPurchaseRowData];
        //data.idGeneralPurchase = event.data.idGeneralPurchase;
        let getItemData = data[event.data.key];
        let setItemData = this.state.inwardItemDetails;

        setItemData.productName = getItemData.productName ? getItemData.productName : "";
        setItemData.idGeneralProduct = setItemData.itemNameList?.find(item => item.name === getItemData.productName)?.id ? setItemData.itemNameList?.find(item => item.name === getItemData.productName)?.id : 0;//find
        setItemData.quantity = getItemData.quantity;
        setItemData.rate = getItemData.rate;
        setItemData.amount = getItemData.amount;
        setItemData.discount = getItemData.discount;
        setItemData.discountAmt = getItemData.discount > 0 ? (getItemData.amount / 100) * Number(getItemData.discount) : 0;
        setItemData.chargesAmt = getItemData.chargesAmt;
        setItemData.netTotal = getItemData.netTotal;
        setItemData.idTaxGroup = getItemData.idTaxGroup;
        setItemData.taxGroup = setItemData.taxGroupList?.find(item => item.id === getItemData.idTaxGroup)?.name;
        setItemData.sgst = getItemData.sgst;
        setItemData.sgstAmount = getItemData.sgstAmount;
        setItemData.cgst = getItemData.cgst;
        setItemData.cgstAmount = getItemData.cgstAmount;
        setItemData.igst = getItemData.igstAmount > 0 ? getItemData.igst : 0;
        setItemData.igstAmount = getItemData.igstAmount;
        setItemData.netPayble = getItemData.netPayble;
        setItemData.remarks = getItemData.remarks;
        setItemData.key = event.data.key;
        setItemData.idUnit = getItemData.idUnit;
        setItemData.unitDescription = setItemData.unitList?.find(item => item.id === getItemData.idUnit)?.name;

        this.setState({ inwardItemDetails: setItemData });
    };

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")
        if (id) {
            let urlId = decryptAES(id)
            if (urlId) {
                if (urlId != null) {
                    this.setState({ urlId: urlId });
                }
            }
        }


        let prop = getAuthProps()
        //debugger
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser ? prop.idUser : 0 }, () => {
                this.procSelectAllRecordsSP();
                //this.getPrefixSelectPrefix()
            }, () => {
                if (this.gridApi) {
                    this.gridApi.hideOverlay(); // Hide AG Grid's loading overlay
                }
            });
        } else {
            // window.location.href = "/Login";
        }
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 100)
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
        setTimeout(() => {
            this.removeDefaultBorders();
        }, 0);
        // this.gridApi.addEventListener("bodyScroll", this.onGridScroll);
    };
    removeDefaultBorders = () => {
        // Function to remove borders from header and cells

        const pinnedHeader = document.querySelector(".ag-pinned-left-header");
        const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");

        if (pinnedHeader) pinnedHeader.style.borderRight = "none"; // Remove border from the header

        pinnedCells.forEach((cell) => {
            cell.style.borderRight = "none"; // Remove border from pinned cells
        });


        // Initial call to remove borders



    };
    // onGridScroll = (event) => {
    //     // const pinnedHeader = document.querySelector(".ag-pinned-left-header");
    //     const pinnedCells = document.querySelectorAll(".ag-cell-last-left-pinned");
    //     const pinnedrow = document.querySelectorAll("ag-row-even");
    //     const pinnedRow = document.querySelector(".ag-pinned-left-cols-container");

    //     if (event.left > 0) {
    //         // if (pinnedHeader) pinnedHeader.style.borderRight = "1px solid lightgray";
    //         pinnedrow.forEach((cell) => {
    //             cell.style.borderRight = "1px solid lightgray";
    //         });
    //         if (pinnedRow) pinnedRow.style.borderRight = "1px solid lightgray";

    //     } else {
    //         // Hide border when at the left
    //         // if (pinnedHeader) pinnedHeader.style.borderRight = "none";
    //         pinnedCells.forEach((cell) => {
    //             cell.style.borderRight = "none";
    //         });
    //         if (pinnedRow) pinnedRow.style.borderRight = "none";

    //     }
    // };
    getPrefixSelectPrefix = () => {
        let request = {
            formname: "FrmTransactionGeneralPurchase",
            idCompany: this.state.idCompany,
            idCompanyDivision: 0,
        };
        this.accountTransactionServices.getPrefixSelectPrefix(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent[0];
                let dt = this.state.materialInwardDetails;
                if (data) {
                    dt.prefix = data.prefix;
                }
                this.setState({ materialInwardDetails: dt }, () => {
                    this.getInwardNoCount();
                });
            } else {
                this.getInwardNoCount();
            }
        });
    }

    procSelectAllRecordsSP = () => {
        let request = {
            formname: "General Purchase",
            idCompany: this.state.idCompany,
            allowToRateVisible: 1,
            idUser: this.state.idUser,
            //idFinancialYear : null,
            //idPlant : 0,
        };
        this.accountTransactionServices.procSelectAllRecordsSP(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let permissions = response.responseItem.responseContent[0][0];
                if (permissions.view) {
                    let data = response.responseItem.responseContent[1];
                    if (data.length > 0) {
                        const dynamicColDefs = Object.keys(data[0]).map((key) => ({
                            field: key.includes(".") ? key.replace(/\./g, "_") : key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            minWidth: this.getColumnWidth(key),
                            flex: 1,
                            filter: true,
                            floatingFilter: true,
                            width: this.getPinnedWidth(key),
                            hide: ["idGeneralPurchase", "sR.No"].includes(key),
                            pinned: ["inwardNo", "vendor"].includes(key) ? "left" : null,
                            valueGetter: (params) => params.data[key],
                            valueFormatter: key.includes("inwardDate") || key.includes("invoiceDate")
                                ? (params) => {
                                    if (!params.value) return "";
                                    return moment(params.value).format("DD-MM-YYYY");
                                }
                                : undefined,
                        }));
                        var colName = dynamicColDefs[0].field;
                        let id = data ? data[0][colName] : 0;
                        this.setState({
                            rowData: data,
                            colDefs: dynamicColDefs,
                            caption: "General Purchase",
                            colName: colName
                        }, () => {
                            this.setPermissions(permissions);
                            this.procSelectAllRecord2GridviewSP(id, "General Purchase");
                            this.getPrefixSelectPrefix();
                            if (this.state.urlId) {
                                this.openPopUpFromURLId(this.state.urlId)
                            }
                        });
                    } else {
                        this.setPermissions(permissions);
                        if (this.gridApi) {
                            this.gridApi.showNoRowsOverlay();
                        }
                    }
                } else {
                    window.location.href = "/authentication/UnAuthorized";
                }
            } else {
                if (this.gridApi) {
                    this.gridApi.hideOverlay();
                    this.gridApi.showNoRowsOverlay();
                }
                this.getPrefixSelectPrefix();
            }
        });
    }

    setPermissions = (permissions) => {
        let data = this.state.permissions;
        data.isAddEdit = permissions.addEdit;
        data.isDelete = permissions.delete;
        data.isView = permissions.view;
        this.setState({ permissions: data });
    }

    openPopUpFromURLId = (id) => {
        let details = this.state.materialInwardDetails;
        details.idGeneralPurchase = id;
        this.setState({ materialInwardDetails: details }, () => {
            this.getTransaction_GeneralPurchaseSelectbyId();
        });
    };

    getColumnWidth = (key) => {
        const colwidth = {
            "idGeneralPurchase": window.innerWidth * 0.08,
            "sR.No": window.innerWidth * 0.05,
            "inwardNo": window.innerWidth * 0.06,
            "inwardDate": window.innerWidth * 0.08,
            "vendor": window.innerWidth * 0.15,
            "invoiceNo": window.innerWidth * 0.07,
            "invoiceDate": window.innerWidth * 0.08,
            "gatePassNo": window.innerWidth * 0.05,
            "totalQty": window.innerWidth * 0.05,
            "totalAmt": window.innerWidth * 0.05,
            "extraCharges": window.innerWidth * 0.05,
            "discount": window.innerWidth * 0.05,
            "taxAmt": window.innerWidth * 0.06,
            "finalAmt": window.innerWidth * 0.05,
            "isApprove": window.innerWidth * 0.06,
            "approvalStatus": window.innerWidth * 0.06,
        }
        return colwidth[key]
    }
    getPinnedWidth = (key) => {
        const pinnedWidths = {
            "idGeneralPurchase": window.innerWidth * 0.11,
            "sR.No": window.innerWidth * 0.06,
            "inwardNo": window.innerWidth * 0.07,
            "vendor": window.innerWidth * 0.18,
        }
        return pinnedWidths[key];
    }

    getInwardNoCount = () => {
        // this.accountTransactionServices.getInwardNoCount(request).then((response) => {
        //     if (response.statusCode === 200 && response.responseItem !== null) {
        //         let data = response.responseItem.responseContent;
        //debugger;
        let details = this.state.materialInwardDetails;
        let maxIdPaymentMake = this.state.rowData.length > 0
            ? Math.max(...this.state.rowData.map(item => item.idGeneralPurchase))
            : 0;
        let inwardNo = String(maxIdPaymentMake + 1).padStart(3, '0');
        details.inwardNo = details.prefix + inwardNo;
        this.setState({ materialInwardDetails: details }, () => {
            this.getNetworkConfiguration();
        })
        //     }
        // });
    }

    getNetworkConfiguration = () => {
        this.accountTransactionServices.getNetworkConfiguration().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                this.setState({ networkConfiguration: data }, () => {
                    this.getPartyAccountGeneral();
                })
            }
        });
        //this.getPartyAccountGeneral();
    }

    getPartyAccountGeneral = () => {
        this.accountTransactionServices.getPartyAccountGeneral(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.materialInwardDetails;
                res = res.map((x) => ({
                    id: x.idPartyAccount,
                    name: x.partyACName,
                }));
                data.partyAccountGeneral = res;
                data.mainPartyAccountGeneral = res;
                this.setState({ materialInwardDetails: data, partyAccountGeneralForSearch: res }, () => {
                    this.getUnit();
                })
            }
        });
        //this.getUnit();
    }

    getUnit = () => {
        this.accountTransactionServices.getUnit(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.inwardItemDetails;
                res = res.map((x) => ({
                    id: x.idUnit,
                    name: x.unitDescription,
                }));
                data.unitList = res;
                this.setState({ inwardItemDetails: data }, () => {
                    this.getTaxStructure()
                })
            }
        });
        //this.getTaxStructure()
    }

    getTaxStructure = () => {
        this.accountTransactionServices.getTaxStructure(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.inwardItemDetails;
                res = res.map((x) => ({
                    id: x.idTaxStructure,
                    name: x.taxStructureName,
                }));
                data.taxGroupList = res;
                this.setState({ inwardItemDetails: data }, () => {
                    this.getGatePass()
                })
                //this.getGatePass();
            }
        });
        //this.getGatePass();
    }

    getGatePass = () => {
        let request = {
            idCompany: this.state.idCompany,
            updateStatus: this.state.materialInwardDetails.updateStatus,
            idPurchase: this.state.materialInwardDetails.idGeneralPurchase,
        }
        this.accountTransactionServices.getGatePass(request).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.materialInwardDetails;
                if (res.length > 0) {
                    res = res.map((x) => ({
                        id: x.idGatePass,
                        name: x.gatePassNo,
                        secondField: x.party
                    }));
                    data.gatePassNoList = res;
                    data.mainGatePassNoList = res;
                }
                //  else {
                //     data.gatePassNoList = this.state.demoList;
                // }
                this.setState({ materialInwardDetails: data }, () => {
                    this.getGeneralProduct();
                });
            }
        });
        //this.getGeneralProduct();
    }

    getGeneralProduct = () => {
        this.accountTransactionServices.getGeneralProduct(this.state.idCompany).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent;
                let data = this.state.inwardItemDetails;
                res = res.map((x) => ({
                    id: x.idGeneralProduct,
                    name: x.productName,
                }));
                data.itemNameList = res;
                this.setState({ inwardItemDetails: data, itemNameListForSearching: res }, () => {
                    //this.getGatePass()
                });
            }
        });
    }

    getPartyAccountSelectbyID = (id) => {
        this.accountTransactionServices.getPartyAccountSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                //debugger;
                let data = this.state.materialInwardDetails;
                data.modeOfPayment = res.paymentTerms;
                data.address = res.p_Address;
                data.inwardTypeName = res.invoiceType
                data.inwardTypeId = data.inwardType?.find(item => item.name === res.invoiceType)?.id;
                this.setState({ materialInwardDetails: data }, () => {
                    //this.getGatePass()
                });
            }
        });
    }

    getGeneralProductSelectbyID = (id) => {
        this.accountTransactionServices.getGeneralProductSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                //debugger;
                let data = this.state.inwardItemDetails;
                data.rate = res.purchasePrice;
                data.taxGroup = res.idTaxGroup > 0 ? data.taxGroupList?.find(item => item.id === res.idTaxGroup)?.name ? data.taxGroupList?.find(item => item.id === res.idTaxGroup)?.name : "" : data.taxGroup;
                data.idTaxGroup = data.taxGroup ? res.idTaxGroup : data.idTaxGroup;
                data.idUnit = res.idUnit;
                data.unitDescription = res.idUnit > 0 ? data.unitList?.find(item => item.id === res.idUnit)?.name : "";
                this.setState({ inwardItemDetails: data }, () => {
                    //this.getGatePass()
                });
            }
        });
    }

    getTaxStructureSelectbyID = (id) => {
        this.accountTransactionServices.getTaxStructureSelectbyID(id).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let res = response.responseItem.responseContent[0];
                //debugger;
                let data = this.state.inwardItemDetails;
                data.sgst = res.sgst;
                data.cgst = res.cgst;
                data.igst = res.igst;
                //data.taxStructureName = data.taxGroupList?.find(item => item.id === data.idTaxStructure)?.name;
                ///data.unitDescription = data.unitList?.find(item => item.id === data.idUnit)?.name;
                this.setState({ inwardItemDetails: data }, () => {
                    this.itemRateCalculation()
                });
            }
        });
    }

    submitGeneralPurchase = () => {
        // guard against double-submit (rapid double-click / impatient re-click while the save is in flight)
        if (this.isSubmitting) {
            return;
        }
        const isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            if (this.state.generalPurchaseRowData.length === 0) {
                this.SwalServices.Alert("Please add Inward Item details");
            } else {
                let data = this.state.materialInwardDetails
                // let itemData = this.state.inwardItemDetails;
                let amountDetail = this.state.amountDetails;
                let request = {
                    idGeneralPurchase: data.idGeneralPurchase,
                    updateStatus: data.updateStatus,
                    inwardNo: data.inwardNo,
                    inwardDate: data.inwardDate,
                    idPartyAccount: data.idPartyAccount,
                    inwardType: data.inwardTypeName,
                    modeOfPayment: data.modeOfPayment,
                    modeOfDelivery: data.modeOfDelivery,
                    invoiceNo: data.invoiceNo,
                    invoiceDate: data.invoiceDate,
                    personName: data.personName,
                    fileName: data.fileName,
                    fileExtension: data.fileExtension,
                    vehicleNo: data.vehicleNo,
                    inwardBy: data.idInwardBy,
                    totalQty: amountDetail.totalQty,
                    totalAmt: amountDetail.totalAmt,
                    taxAmt: amountDetail.totalTaxAmt,
                    totalWithTax: amountDetail.finalAmt,
                    tcsPercentage: amountDetail.tcsPercentage,
                    tcsAmt: amountDetail.tcsAmt,
                    extraCharges: amountDetail.extraCharges,
                    discount: amountDetail.totalDiscountAmt,
                    finalAmt: amountDetail.finalAmt,
                    taxableAmt: amountDetail.taxableAmt,
                    adjustableAmt: amountDetail.adjustableAmt,
                    remarks: "",
                    idCompany: this.state.idCompany,
                    e_Date: new Date().toISOString(),
                    e_IDUser: data.updateStatus === 1 ? data.e_IDUser : this.state.idUser,
                    isUpdated: data.updateStatus === 1 ? true : data.isUpdated ? data.isUpdated : null,
                    updatedDate: data.updateStatus === 1 ? new Date().toISOString() : data.updatedDate ? data.updatedDate : null,
                    u_IDUser: data.updateStatus === 1 ? this.state.idUser : data.u_IDUser ? data.u_IDUser : null,
                    isDeleted: false,
                    deletedDate: null,
                    d_IDUser: null,
                    prefix: data.prefix, // Non-nullable
                    gatePassNo: data.gatePassNo ? data.gatePassNo.split(',')[0] : '', // Non-nullable
                    idGatePass: data.idGatePass,
                    idFinancialYear: data.idFinancialYear,
                };
                request.AdditionalItemList = [];//this.state.generalPurchaseRowData;
                let itemList = this.state.generalPurchaseRowData;
                itemList.map((details) => {
                    let obj = {
                        idGeneralProduct: details.idGeneralProduct,
                        productName: details.productName,
                        quantity: details.quantity,
                        rate: details.rate,
                        amount: details.amount,
                        discount: details.discount,
                        discountAmt: details.discountAmt,
                        extraCharges: details.chargesAmt,
                        taxableAmt: details.netTotal,
                        idTaxGroup: details.idTaxGroup,
                        sgst: details.sgst,
                        sgstAmt: details.sgstAmount,
                        cgst: details.cgst,
                        cgstAmt: details.cgstAmount,
                        igst: details.igstAmount > 0 ? details.igst : 0,
                        igstAmt: details.igstAmount,
                        netTotal: details.netPayble,
                        itemRemarks: details.remarks,
                        idUnit: details.idUnit,
                    }
                    request.AdditionalItemList.push(obj);
                });
                this.isSubmitting = true;
                this.setState({ isSaving: true });
                this.accountTransactionServices.submitGeneralPurchase(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let data = response.responseItem.responseContent;
                        if (data !== null) {
                            if (this.state.materialInwardDetails.updateStatus === 1) {
                                this.SwalServices.Success("Updated sucessfully.");
                            } else {
                                this.SwalServices.Success("Save sucessfully.");
                            }
                            if (this.state.urlId) {
                                this.setState({ route: '/ledger-report' });
                            } else {
                                this.setState({
                                    isModalOpen: false,
                                    //receiptDetails: reset
                                }, () => {
                                    this.resetFields();
                                    this.procSelectAllRecordsSP();
                                });
                            }
                        }
                    }
                }).finally(() => {
                    this.isSubmitting = false;
                    this.setState({ isSaving: false });
                });
            }
        }
    }

    getTransaction_GeneralPurchaseSelectbyId = () => {
        let id = this.state.materialInwardDetails.idGeneralPurchase;
        if (id) {
            let details = this.state.materialInwardDetails
            details.updateStatus = 1
            this.setState({ materialInwardDetail: details }, () => {
                let request = {
                    idCompany: this.state.idCompany,
                    updateStatus: this.state.materialInwardDetails.updateStatus,
                    idPurchase: this.state.materialInwardDetails.idGeneralPurchase,
                }
                this.accountTransactionServices.getGatePass(request).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        let res = response.responseItem.responseContent;
                        let data = this.state.materialInwardDetails;
                        if (res.length > 0) {
                            res = res.map((x) => ({
                                id: x.idGatePass,
                                name: x.gatePassNo,
                                secondField: x.party
                            }));
                            data.gatePassNoList = res;
                            data.mainGatePassNoList = res;
                        }
                        this.setState({ materialInwardDetails: data }, () => {
                            this.accountTransactionServices.getTransaction_GeneralPurchaseSelectbyId(id).then((response) => {
                                if (response.statusCode === 200 && response.responseItem !== null) {
                                    let data = response.responseItem.responseContent;
                                    if (data !== null) {
                                        this.accountTransactionServices.getPartyAccountSelectbyID(data.idPartyAccount).then((response2) => {
                                            if (response2.statusCode === 200 && response2.responseItem !== null) {
                                                let res = response2.responseItem.responseContent[0];

                                                let materialInwardDetail = this.state.materialInwardDetails;

                                                materialInwardDetail.idGeneralPurchase = data.idGeneralPurchase;
                                                materialInwardDetail.updateStatus = 1;
                                                //materialInwardDetail.prefix = ,
                                                materialInwardDetail.inwardNo = data.inwardNo;
                                                materialInwardDetail.inwardDate = moment(data.inwardDate).format('YYYY-MM-DD'); //data.inwardDate;
                                                materialInwardDetail.inwardTypeName = data.inwardType;
                                                materialInwardDetail.inwardTypeId = materialInwardDetail.inwardType?.find(item => item.name === data.inwardType)?.id;
                                                materialInwardDetail.modeOfDelivery = data.modeOfDelivery;
                                                materialInwardDetail.idPartyAccount = data.idPartyAccount;
                                                materialInwardDetail.partyACName = materialInwardDetail.partyAccountGeneral?.find(item => item.id === data.idPartyAccount)?.name; // find
                                                materialInwardDetail.gatePassNo = data.gatePassNo + ', ' + materialInwardDetail.partyACName;
                                                materialInwardDetail.idGatePass = data.gatePassNo ?
                                                    materialInwardDetail.gatePassNoList?.find(item => item.name === data.gatePassNo) ? materialInwardDetail.gatePassNoList?.find(item => item.name === data.gatePassNo)?.id : 0
                                                    : 0; // find
                                                //materialInwardDetail.partyAccountGeneral= data.partyAccountGeneral
                                                materialInwardDetail.modeOfPayment = data.modeOfPayment;
                                                materialInwardDetail.personName = data.personName;
                                                materialInwardDetail.invoiceNo = data.invoiceNo;
                                                materialInwardDetail.invoiceDate = moment(data.invoiceDate).format('YYYY-MM-DD');
                                                materialInwardDetail.vehicleNo = data.vehicleNo;
                                                materialInwardDetail.selectFile = ""; //data.fileName;
                                                materialInwardDetail.fileExtension = data.fileExtension;
                                                //materialInwardDetail.selectedFile = 
                                                // materialInwardDetail.inwardByList: [],
                                                materialInwardDetail.idInwardBy = data.inwardBy;
                                                materialInwardDetail.inwardBy = data.inwardBy > 0 ? materialInwardDetail.inwardByList?.find(item => item.id === data.inwardBy)?.name : ""; // find
                                                materialInwardDetail.idFinancialYear = data.idFinancialYear;
                                                materialInwardDetail.address = res.p_Address;
                                                //materialInwardDetail.add = res.p_Address;
                                                let itemList = this.state.generalPurchaseRowData;
                                                let itemDetail = this.state.inwardItemDetails;
                                                let list = [];
                                                data.iteamList.map((x) => {
                                                    let obj = {};
                                                    obj.productName = x.productName;
                                                    obj.idGeneralProduct = itemDetail.itemNameList?.find(item => item.name === x.productName)?.id; //find
                                                    //obj.debugger;
                                                    obj.quantity = x.inwardQuantity;
                                                    obj.rate = x.rate;
                                                    obj.amount = x.amount;
                                                    obj.discount = x.discount;
                                                    obj.discountAmt = x.discount > 0 ? (x.amount / 100) * Number(x.discount) : 0; // calu
                                                    obj.chargesAmt = x.extraCharges;
                                                    obj.netTotal = x.taxableAmt;
                                                    obj.idTaxGroup = x.idTaxGroup;
                                                    obj.taxGroup = itemDetail.taxGroupList?.find(item => item.id === x.idTaxGroup)?.name;
                                                    //idTaxGroup = x.idTaxGroup;
                                                    //taxGroup = details.taxGroup;
                                                    obj.sgst = x.sgst;
                                                    obj.sgstAmount = x.sgstAmt;
                                                    obj.cgst = x.cgst;
                                                    obj.cgstAmount = x.cgstAmt;
                                                    obj.igst = x.igstAmt > 0 ? x.igst : 0;
                                                    obj.igstAmount = x.igstAmt;
                                                    obj.netPayble = x.netTotal;
                                                    obj.remarks = x.itemRemarks;
                                                    obj.idUnit = x.idUnit;
                                                    obj.unitDescription = x.idUnit > 0 ? itemDetail.unitList?.find(item => item.id === x.idUnit)?.name : "";
                                                    //}
                                                    list.push(obj);
                                                })
                                                list.map((x, key) => {
                                                    x.key = key;
                                                });

                                                itemList = [...list];

                                                //itemList.push(...data.iteamList);
                                                //debugger;

                                                let amountDetail = this.state.amountDetails;
                                                amountDetail.totalQty = data.totalQty;
                                                //amountDetail.totalQty = data. ;
                                                amountDetail.totalAmt = data.totalAmt;
                                                amountDetail.extraCharges = data.extraCharges;
                                                amountDetail.totalDiscountAmt = data.discount;
                                                amountDetail.taxAmt = data.taxAmt;
                                                amountDetail.tcsPercentage = data.tcsPercentage;
                                                amountDetail.tcsAmt = data.tcsAmt;
                                                amountDetail.totalTaxAmt = data.taxAmt;
                                                amountDetail.finalAmt = data.finalAmt;
                                                amountDetail.taxableAmt = data.taxableAmt;
                                                amountDetail.adjustableAmt = data.adjustableAmt;
                                                this.setState({ materialInwardDetails: materialInwardDetail, isModalOpen: true, generalPurchaseRowData: itemList, amountDetails: amountDetail }, () => {
                                                    //this.finalCalculation();
                                                })
                                            }
                                        });
                                        // if (this.state.materialInwardDetails.updateStatus === 1) {
                                        //     this.SwalServices.Success("Updated sucessfully.");
                                        // } else {
                                        //     this.SwalServices.Success("Save sucessfully.");
                                        // }
                                        // this.setState({
                                        //     isModalOpen: false,
                                        //     //receiptDetails: reset
                                        // }, () => {
                                        //     this.resetFields();
                                        //     this.procSelectAllRecordsSP();
                                        // });
                                    }
                                }
                            });
                        });
                    }
                });
            })
        }
    }


    resetFields = () => {
        let validState = this.state.validStateForMaterialInwardDetails;
        validState.isValid = true;
        validState.error = {};
        let resetMaterialData = this.state.materialInwardDetails
        resetMaterialData.prefix = "";
        resetMaterialData.idGeneralPurchase = 0;
        resetMaterialData.updateStatus = 0;
        resetMaterialData.prefix = "";
        resetMaterialData.inwardNo = "";
        resetMaterialData.inwardDate = moment(new Date().toISOString()).format('YYYY-MM-DD');
        resetMaterialData.inwardTypeId = 1;
        resetMaterialData.inwardTypeName = "INTRASTATE";
        resetMaterialData.idGatePass = 0;
        resetMaterialData.gatePassNo = "";
        resetMaterialData.modeOfDelivery = "";
        resetMaterialData.idPartyAccount = 0;
        resetMaterialData.partyACName = "";
        resetMaterialData.modeOfPayment = "";
        resetMaterialData.personName = "";
        resetMaterialData.invoiceNo = "";
        resetMaterialData.invoiceDate = "";
        resetMaterialData.vehicleNo = "";
        resetMaterialData.selectFile = "";
        resetMaterialData.selectedFile = null;
        resetMaterialData.idInwardBy = "";
        resetMaterialData.inwardBy = "";
        resetMaterialData.address = "";
        resetMaterialData.idTaxGroup = "";
        resetMaterialData.taxGroup = "";

        let amountDetail = this.state.amountDetails;
        amountDetail.totalQty = "";
        amountDetail.totalAmt = "";
        amountDetail.extraCharges = "";
        amountDetail.totalDiscountAmt = "";
        amountDetail.taxAmt = "";
        amountDetail.tcsPercentage = "";
        amountDetail.tcsAmt = "";
        amountDetail.totalTaxAmt = "";
        amountDetail.finalAmt = "";
        amountDetail.taxableAmt = "";
        amountDetail.adjustableAmt = "";

        this.setState({ materialInwardDetails: resetMaterialData, amountDetails: amountDetail, generalPurchaseRowData: [], validStateForMaterialInwardDetails: validState }, () => {
            this.resetInwardItemDetails();
        });
    }

    closePopup = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        } else {
            this.setState({ isModalOpen: false, });
        }
    };

    onRowDoubleClicked = (event) => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.edit);
            return;
        }
        this.getTransaction_GeneralPurchaseSelectbyId(event);
    };

    procSelectAllRecord2GridviewSP = (id, formname) => {
        //debugger;
        let request = {
            id: id,
            formname: formname,
            allowToRateVisible: 1,
            //idCompany: this.state.prop.idCompany
        }
        //debugger
        if (id > 0) {
            this.accountTransactionServices.procSelectAllRecord2GridviewSP(request).then((response) => {
                //debugger
                if (response.statusCode === 200 && response.responseItem !== null) {
                    //debugger;
                    const dynamicData = response.responseItem.responseContent;
                    if (dynamicData.length > 0) {
                        const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
                            field: key,
                            headerName: key.replace(/([A-Z])/g, ' $1').charAt(0).toUpperCase() + key.replace(/([A-Z])/g, ' $1').slice(1),
                            flex: 1,
                            minWidth: this.table2ColWidth(key),
                            pinned: this.table2PinnedWidth(key) ? "left" : null,
                            width: this.table2ColWidth(key),
                        }));
                        this.setState({
                            table2Data: dynamicData,
                            table2ColDefs: dynamicColDefs,
                            isTable2Expanded: true
                        });
                    } else {
                        this.setState({
                            table2Data: [],
                            table2ColDefs: [],
                            isTable2Expanded: false
                        });
                    }
                }
            });
        }
    }

    // handleUpload = () => {
    //     const { selectedFile } = this.state;
    //     if (!selectedFile) {
    //         this.setState({ uploadStatus: "Please select a file first." });
    //         return;
    //     }
    //     const formData = new FormData();
    //     formData.append("file", selectedFile); // Name should match API parameter
    //     // try {
    //     // const response = axios.post(
    //     //     "http://localhost:5000/api/FileUpload/upload",
    //     //     formData,
    //     //     {
    //     //         headers: { "Content-Type": "multipart/form-data" },
    //     //     }
    //     // );

    //     this.accountTransactionServices.uploadFile(formData).then((response) => {
    //         debugger
    //         if (response.statusCode === 200 && response.responseItem !== null) {
    //             debugger;
    //             const dynamicData = response.responseItem.responseContent;
    //             if (dynamicData.length > 0) {
    //                 const dynamicColDefs = Object.keys(dynamicData[0]).map((key) => ({
    //                     field: key,
    //                     headerName: key,
    //                     flex: 1,
    //                     minWidth: this.table2ColWidth(key),
    //                     pinned: this.table2PinnedWidth(key) ? "left" : null,
    //                     width: this.table2ColWidth(key),
    //                 }));
    //                 this.setState({
    //                     table2Data: dynamicData,
    //                     table2ColDefs: dynamicColDefs,
    //                     isTable2Expanded: true
    //                 });
    //             }
    //         }
    //     });
    //     //this.setState({ uploadStatus: `Success: ${response.data.message}` });
    //     //console.log("File uploaded:", response.data);
    //     // } catch (error) {
    //     //     this.setState({
    //     //         uploadStatus: `Error: ${error.response?.data?.message || error.message}`,
    //     //     });
    //     //     console.error("Upload error:", error);
    //     // }
    // };

    itemRateCalculation = () => {
        let materialInwardDetail = this.state.materialInwardDetails;
        let data = this.state.inwardItemDetails;
        data.amount = Number(data.quantity) * Number(data.rate);
        data.netTotal = Number(data.amount);
        data.discountAmt = (data.amount / 100) * Number(data.discount);
        data.netTotal = data.netTotal - data.discountAmt; //((data.amount / 100) * Number(data.discount));
        data.netTotal = data.netTotal + Number(data.chargesAmt);

        //if (data.sgst > 0 || data.cgst > 0) {
        data.sgstAmount = materialInwardDetail.inwardTypeName === 'INTRASTATE' ? (data.netTotal * data.sgst) / 100 : 0;
        data.cgstAmount = materialInwardDetail.inwardTypeName === 'INTRASTATE' ? (data.netTotal * data.sgst) / 100 : 0;
        data.igstAmount = data.igst > 0 ? materialInwardDetail.inwardTypeName === 'INTRASTATE' ? 0 : (data.netTotal * data.sgst) / 100 : 0;
        //}
        data.netPayble = data.netTotal + data.sgstAmount + data.cgstAmount + data.igstAmount;
        this.setState({ inwardItemDetails: data });
    }

    finalCalculation = () => {
        let data = this.state.generalPurchaseRowData;
        let finalAmountCal = this.state.amountDetails;
        finalAmountCal.totalQty = "";
        finalAmountCal.totalAmt = "";
        finalAmountCal.extraCharges = "";
        finalAmountCal.totalDiscountAmt = "";
        finalAmountCal.taxAmt = "";
        //finalAmountCal.tcsPercentage = 0;
        finalAmountCal.tcsAmt = "";
        finalAmountCal.totalTaxAmt = "";
        finalAmountCal.finalAmt = "";
        finalAmountCal.taxableAmt = "";
        data.map((x) => {
            finalAmountCal.totalQty = Number(finalAmountCal.totalQty) + Number(x.quantity);
            finalAmountCal.totalAmt = Number(finalAmountCal.totalAmt) + Number(x.amount);
            finalAmountCal.extraCharges = Number(finalAmountCal.extraCharges) + Number(x.chargesAmt);
            finalAmountCal.totalDiscountAmt = Number(finalAmountCal.totalDiscountAmt) + Number(x.discountAmt);
            finalAmountCal.totalTaxAmt = Number(finalAmountCal.totalTaxAmt) + Number(x.sgstAmount + x.cgstAmount + x.igstAmount);
            finalAmountCal.finalAmt = Number(finalAmountCal.finalAmt) + Number(x.netPayble);
            finalAmountCal.taxableAmt = Number(finalAmountCal.taxableAmt) + Number(x.netTotal);
        });

        //finalAmountCal.finalAmt = finalAmountCal.totalAmt + finalAmountCal.extraCharges + 
        finalAmountCal.tcsAmt = Number(finalAmountCal.tcsPercentage) > 0 ? Number(finalAmountCal.finalAmt * Number(finalAmountCal.tcsPercentage)) / 100 : 0;
        finalAmountCal.finalAmt = Number(finalAmountCal.finalAmt + finalAmountCal.tcsAmt).toFixed(2);

        finalAmountCal.totalAmt = Number((finalAmountCal.totalAmt)).toFixed(2);
        finalAmountCal.extraCharges = Number((finalAmountCal.extraCharges)).toFixed(2);
        finalAmountCal.totalDiscountAmt = Number((finalAmountCal.totalDiscountAmt)).toFixed(2);
        finalAmountCal.taxableAmt = Number((finalAmountCal.taxableAmt)).toFixed(2);
        finalAmountCal.totalTaxAmt = Number((finalAmountCal.totalTaxAmt)).toFixed(2);
        finalAmountCal.tcsAmt = Number((finalAmountCal.tcsAmt)).toFixed(2);
        const finalAmt = Number(finalAmountCal?.finalAmt || 0);
        const adjustableAmt = Number(finalAmountCal?.adjustableAmt || 0);

        finalAmountCal.finalAmt = Math.round(finalAmt + adjustableAmt);
        this.setState({ amountDetails: finalAmountCal });
    }

    table2ColWidth = (key) => {
        const colWidth = {
            "productName": window.innerWidth * 0.15,
            "inwardQuantity": window.innerWidth * 0.1,
            "rate": window.innerWidth * 0.1,
            "taxableAmt": window.innerWidth * 0.1,
            "sgst": window.innerWidth * 0.05,
            "sgstAmt": window.innerWidth * 0.06,
            "cgst": window.innerWidth * 0.05,
            "cgstAmt": window.innerWidth * 0.06,
            "igst": window.innerWidth * 0.05,
            "igstAmt": window.innerWidth * 0.06,
            "netTotal": window.innerWidth * 0.08,
            "itemRemarks": window.innerWidth * 0.1,
        }
        return colWidth[key];
    }
    table2PinnedWidth = (key) => {
        const pinnedWidths = {
            "productName": window.innerWidth * 0.1,
            "inwardQuantity": window.innerWidth * 0.1,
            "rate": window.innerWidth * 0.08,
            "taxableAmt": window.innerWidth * 0.08,
        }
        return pinnedWidths[key];
    }

    setOpenModel = () => {
        if (this.state.urlId) {
            this.setState({ route: '/ledger-report' });
        }
        this.setState({ isModalOpen: !this.state.isModalOpen }, () => {
            if (!this.state.isModalOpen) {
                this.resetFields();
                this.resetInwardItemDetails();
            }
            //this.getPrefixSelectPrefix();
        });

    };

    openPopUpForAddingItem = () => {
        if (!this.state.permissions.isAddEdit) {
            this.SwalServices.Error(permission.add);
            return;
        }
        this.resetFields();
        this.setState({ isModalOpen: true }, () => {
            this.getPrefixSelectPrefix();
        });
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.materialInwardDetails;
        if (name === 'selectFile') {
            details.selectedFile = event.target.files[0]
        }
        details[name] = value;
        this.setState({ materialInwardDetails: details });
    }

    handleChangeForItem = (event, name) => {
        let value = event.target.value;
        let details = this.state.inwardItemDetails;
        details[name] = value;
        this.setState({ inwardItemDetails: details }, () => {
            // if(name === ''){

            // }
            this.itemRateCalculation();
        });
    }

    handleChangeFinalCalculation = (event, name) => {
        let value = event.target.value;
        let details = this.state.amountDetails;
        details[name] = value;
        this.setState({ amountDetails: details }, () => {
            this.finalCalculation();
        });
    }

    setFilterParameters = (id, name, drpIdentity, secondField) => {
        //var arr = [...this.state.ListSingleSelect]
        //if (id > 0) {
        //debugger;
        let data = this.state.materialInwardDetails;
        let inwardItemDetail = this.state.inwardItemDetails;
        if (drpIdentity === 'inwardType') {
            data.inwardTypeId = id;
            data.inwardTypeName = name;
        } else if (drpIdentity === 'gatePassNo') {
            data.idGatePass = id;
            data.gatePassNo = name + ', ' + ((secondField && secondField !== '') ? secondField : '');
            let partyName = id > 0 ? this.state.materialInwardDetails.gatePassNoList.find(x => x.id === id).secondField : ''
            let partyId = partyName !== '' ? this.state.materialInwardDetails.partyAccountGeneral.find(x => x.name === partyName).id : 0
            this.setFilterParameters(partyId, partyName, 'partyAccountGeneral')
        } else if (drpIdentity === 'partyAccountGeneral') {
            data.idPartyAccount = id;
            data.partyACName = name;
        } else if (drpIdentity === 'inwardBy') {
            data.idInwardBy = id;
            data.inwardBy = name;
        }
        else if (drpIdentity === 'itemName') {
            inwardItemDetail.idGeneralProduct = id;
            inwardItemDetail.productName = name;
        } else if (drpIdentity === 'taxGroup') {
            inwardItemDetail.idTaxStructure = id;
            inwardItemDetail.taxStructureName = name;
        } else if (drpIdentity === 'unit') {
            inwardItemDetail.idUnit = id;
            inwardItemDetail.unitDescription = name;
        }
        // else if (drpIdentity === 'partyAccountGeneral') {
        //     inwardItemDetail.idUnit = id;
        //     inwardItemDetail.unitDescription = name;
        // }
        this.setState({
            materialInwardDetails: data,
        }, () => {
            if (drpIdentity === 'partyAccountGeneral') {
                this.getPartyAccountSelectbyID(id);
            }
            if (drpIdentity === 'gatePassNo') {
                this.getPartyAccountSelectbyID_withGatePass()
            }
        });
        //}
    };

    getPartyAccountSelectbyID_withGatePass = () => {
        if (this.state.materialInwardDetails.idPartyAccount > 0) {
            let request = [this.state.materialInwardDetails.idPartyAccount, this.state.materialInwardDetails.idGatePass];
            this.transactionStockServices.getPartyAccountSelectbyID_withGatePass(request).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let res = response.responseItem.responseContent[0];
                    //debugger;
                    let data = this.state.materialInwardDetails;
                    //data.modeOfPayment = res.paymentTerms;
                    data.address = res.p_Address;
                    data.invoiceNo = res.invoiceNo;
                    data.invoiceDate = res.invoiceDate ? moment(res.invoiceDate).format('YYYY-MM-DD') : null;
                    this.setState({ materialInwardDetails: data });
                }
            });
        }
    }

    setFilterParametersItme = (id, name, drpIdentity) => {
        let inwardItemDetail = this.state.inwardItemDetails;
        if (drpIdentity === 'itemName') {
            inwardItemDetail.idGeneralProduct = id;
            inwardItemDetail.productName = name;
        } else if (drpIdentity === 'taxGroup') {
            inwardItemDetail.idTaxGroup = id;
            inwardItemDetail.taxGroup = name;
        } else if (drpIdentity === 'unit') {
            inwardItemDetail.idUnit = id;
            inwardItemDetail.unitDescription = name;
        }
        this.setState({
            inwardItemDetails: inwardItemDetail
        }, () => {
            if (drpIdentity === 'itemName') {
                this.getGeneralProductSelectbyID(id);
            } else if (drpIdentity === 'taxGroup') {
                this.getTaxStructureSelectbyID(id);
            }
        });
        //}
    };

    handleSearching = (event, name) => {
        if (name === 'itemName') {
            //debugger
            let arr = [...this.state.itemNameListForSearching];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.inwardItemDetails;
            data.productName = value;
            data.itemNameList = found;
            this.setState({ inwardItemDetails: data });
        } else if (name === 'gatePassNo') {
            //debugger
            let arr = [...this.state.materialInwardDetails.mainGatePassNoList];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.materialInwardDetails;
            data.gatePassNo = value;
            data.gatePassNoList = found;
            this.setState({ materialInwardDetails: data });
        } else if (name === 'partyAccountGeneral') {
            //debugger
            let arr = [...this.state.materialInwardDetails.mainPartyAccountGeneral];
            let value = "";
            value = event.target.value;
            let found;
            if (value === "" || value === null) {
                found = arr;
            } else {
                found = arr.filter((element) =>
                    element.name.toLowerCase().includes(value.toLowerCase())
                );
            }
            let data = this.state.materialInwardDetails;
            data.partyACName = value;
            data.partyAccountGeneral = found;
            this.setState({ materialInwardDetails: data });
        }
    }

    handleSelectChange = (event, name) => {
        let select = event.target.value;
        let details = this.state.debitNoteDetails;
        details[name] = select;
        this.setState({ debitNoteDetails: details });
    }

    saveItem = () => {
        let details = this.state.materialInwardDetails;
        console.log(details);
    }

    insertItem = (flag) => {
        const isValidAllFields = this.isValidInwardFields();
        if (isValidAllFields) {
            if (flag === 'Insert') {
                let details = this.state.inwardItemDetails;
                let itemList = [...this.state.generalPurchaseRowData];
                let obj = {
                    idGeneralProduct: details.idGeneralProduct,
                    productName: details.productName,
                    quantity: details.quantity,
                    rate: details.rate,
                    amount: details.amount,
                    discount: details.discount,
                    discountAmt: details.discountAmt,
                    chargesAmt: details.chargesAmt,
                    netTotal: details.netTotal,
                    //idTaxStructure: details.idTaxStructure,
                    //taxStructureName: details.taxStructureName,
                    idTaxGroup: details.idTaxGroup,
                    taxGroup: details.taxGroup,
                    sgst: details.sgst,
                    sgstAmount: details.sgstAmount,
                    cgst: details.cgst,
                    cgstAmount: details.cgstAmount,
                    igst: details.igstAmount > 0 ? details.igst : 0,
                    igstAmount: details.igstAmount,
                    netPayble: details.netPayble,
                    remarks: details.remarks,
                    idUnit: details.idUnit,
                    unitDescription: details.unitDescription,
                }
                itemList.push(obj);
                itemList.map((x, key) => {
                    x.key = key;
                });
                this.setState({ generalPurchaseRowData: itemList }, () => {
                    this.resetInwardItemDetails();
                    this.finalCalculation();
                });
            }
            else if (flag === 'Update') {
                let details2 = this.state.inwardItemDetails;
                let itemList2 = [...this.state.generalPurchaseRowData];
                let obj2 = {};
                obj2.idGeneralProduct = details2.idGeneralProduct;
                obj2.productName = details2.productName;
                obj2.quantity = Number(details2.quantity);
                obj2.rate = Number(details2.rate);
                obj2.amount = Number(details2.amount);
                obj2.discount = Number(details2.discount);
                obj2.discountAmt = Number(details2.discountAmt);
                obj2.chargesAmt = Number(details2.chargesAmt);
                obj2.netTotal = Number(details2.netTotal);
                //idTaxStructure = details.idTaxStructure;
                //taxStructureName = details.taxStructureName;
                obj2.idTaxGroup = details2.idTaxGroup;
                obj2.taxGroup = details2.taxGroup;
                obj2.sgst = details2.sgst;
                obj2.sgstAmount = Number(details2.sgstAmount);
                obj2.cgst = details2.cgst;
                obj2.cgstAmount = Number(details2.cgstAmount);
                obj2.igst = details2.igstAmount > 0 ? details2.igst : 0;
                obj2.igstAmount = Number(details2.igstAmount);
                obj2.netPayble = Number(details2.netPayble);
                obj2.remarks = details2.remarks;
                obj2.idUnit = details2.idUnit;
                obj2.unitDescription = details2.unitDescription;
                //}
                itemList2[details2.key] = obj2;
                itemList2.map((x, key) => {
                    x.key = key;
                });
                this.setState({ generalPurchaseRowData: itemList2 }, () => {
                    this.resetInwardItemDetails();
                    this.finalCalculation();
                });
            }
        }
    }

    resetInwardItemDetails = () => {
        let details = this.state.inwardItemDetails;
        details.idGeneralProduct = 0;
        details.productName = "";
        details.idUnit = 0;
        details.unitDescription = "";
        details.quantity = 0;
        details.rate = 0;
        details.amount = 0;
        details.discount = 0;
        details.chargesAmt = 0;
        details.netTotal = 0;
        //details.idTaxStructure = "";
        //details.taxStructureName = "";
        details.idTaxGroup = "";
        details.taxGroup = "";
        details.sgst = "";
        details.sgstAmount = "";
        details.cgst = "";
        details.cgstAmount = "";
        details.igst = "";
        details.igstAmount = "";
        details.netPayble = "";
        details.remarks = "";
        details.key = "";
        this.setState({ inwardItemDetails: details })
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.materialInwardDetails,
            this.state.validationRulesForMaterialInwardDetails,
            this.state.validStateForMaterialInwardDetails,
        );
        this.setState({ validStateForMaterialInwardDetails: newValidState });
        return newValidState.isValid;
    }

    isValidInwardFields = () => {
        const newValidState = isValidForm(
            this.state.inwardItemDetails,
            this.state.validationRulesForInwardItemDetails,
            this.state.validStateForInwardItemDetails,
        );
        this.setState({ validStateForInwardItemDetails: newValidState });
        return newValidState.isValid;
    }
    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='gengeral-purchase'>
                <div className="data-display">
                    <div className="data-display-inner relative">
                        <ButtonGrp buttons={['add', 'print', 'delete']}
                            onClickHandlers={{
                                add: () => this.openPopUpForAddingItem(),
                                // update: () => this.getTransaction_GeneralPurchaseSelectbyId(),
                                print: this.handlePrint,
                                delete: this.handleDelete,
                            }}
                        />
                        <GeneralPurchasePopUp
                            isModalOpen={this.state.isModalOpen}
                            setOpenModel={this.setOpenModel.bind(this)}
                            close={this.closePopup.bind(this)}
                            handleChange={this.handleChange.bind(this)}
                            handleSelectChange={this.handleSelectChange.bind(this)}
                            setFilterParameters={this.setFilterParameters.bind(this)}
                            setFilterParametersItme={this.setFilterParametersItme.bind(this)}
                            materialInwardDetails={this.state.materialInwardDetails}
                            inwardItemDetails={this.state.inwardItemDetails}
                            amountDetails={this.state.amountDetails}
                            generalPurchaseRowData={this.state.generalPurchaseRowData}
                            saveItem={this.saveItem.bind(this)}
                            validStateMaterial={this.state.validStateForMaterialInwardDetails}
                            validStateInward={this.state.validStateForInwardItemDetails}
                            handleSearching={this.handleSearching.bind(this)}
                            handleChangeForItem={this.handleChangeForItem.bind(this)}
                            insertItem={this.insertItem.bind(this)}
                            handleChangeFinalCalculation={this.handleChangeFinalCalculation.bind(this)}
                            submitGeneralPurchase={this.submitGeneralPurchase.bind(this)}
                            isSaving={this.state.isSaving}
                            handleCellClickItemList={this.handleCellClickItemList.bind(this)}
                        />
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 h-[68vh] w-full px-[1px] rounded-[5px]">
                                <div className="table-inner">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">General purchase</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    headerHeight={65}
                                    columnDefs={this.state.colDefs}
                                    pagination={true}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onCellClicked={this.handleCellClick}
                                    onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                />
                            </div>
                        </div>
                        <div className="table w-full mt-[10px] bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className={`table-2 w-full px-[1px] rounded-[5px] ${this.state.isTable2Expanded ? 'h-[448px]' : 'h-[0]'}`}>
                                <div className="table-inner" onClick={() => this.toggleExpandCollapseTable(2)}>
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Details</h1>
                                </div>
                                <AgGridReact
                                    rowData={this.state.table2Data}
                                    columnDefs={this.state.table2ColDefs}
                                    rowHeight={this.state.rowHeight}
                                    pagination={true}
                                    paginationPageSize={this.state.paginationPageSize}
                                    onGridReady={this.onGridReady}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default GeneralPurchase;